const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  FORGOT_ERROR: 'FORGOT_ERROR',
  FORGOT_CLEAR: 'FORGOT_CLEAR', // For resetting forgot password page error banner
  FORGOT_DESC_HIDE: 'FORGOT_DESC_HIDE', // For forgot password page description
  FORGOT_DESC_SHOW: 'FORGOT_DESC_SHOW',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SUBMODULES: 'SUBMODULES',
  SET_LOADING: 'SET_LOADING',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_DONE: 'FORGOT_PASSWORD_DONE',
  RESET_FORGOT_PASSWORD: 'RESET_FORGOT_PASSWORD',
  SIGNUP: 'SIGNUP',
  SIGNUP_ERROR: 'SIGNUP_ERROR',
  RESET_SECOND_TIMER: 'RESET_SECOND_TIMER',
  ON_RESET_TIMER: 'ON_RESET_TIMER',
  LOGIN_VALIDATOR: 'LOGIN_VALIDATOR',
  FORBIDDEN_REQUEST: 'FORBIDDEN_REQUEST',
  KICKED_OUT: 'KICKED_OUT',
  KICKED_OUT_CLEAR: 'KICKED_OUT_CLEAR',
  SET_HELLO: 'SET_HELLO',
  FETCH_REDIRECT_URL: 'FETCH_REDIRECT_URL',
  FETCH_RESET_PASSWORD_URL: 'FETCH_RESET_PASSWORD_URL',
  FETCHING_RESET_PASSWORD_URL: 'FETCHING_RESET_PASSWORD_URL',
  FETCHED_RESET_PASSWORD_URL: 'FETCHED_RESET_PASSWORD_URL',
  FETCH_RESET_PASSWORD_URL_FAILED: 'FETCH_RESET_PASSWORD_URL_FAILED',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD', // trigger
  CHANGING_PASSWORD: 'CHANGING_PASSWORD', // loading
  CHANGED_PASSWORD: 'CHANGED_PASSWORD', // success
  CHANGED_PASSWORD_FAILED: 'CHANGED_PASSWORD_FAILED', //failed
  RESET_CHANGE_PASSWORD: 'RESET_CHANGE_PASSWORD', //reset,

  UPDATE_USER_NOTIFICATION: 'UPDATE_USER_NOTIFICATION',
  UPDATING_USER_NOTIFICATION: 'UPDATING_USER_NOTIFICATION',
  UPDATE_USER_NOTIFICATION_SUCCESS: 'UPDATE_USER_NOTIFICATION_SUCCESS',
  UPDATE_USER_NOTIFICATION_FAILED: 'UPDATE_USER_NOTIFICATION_FAILED',
  RESET_UPDATE_USER_NOTIFICATION: 'RESET_UPDATE_USER_NOTIFICATION',

  UPDATE_USER_E_SIGNATURE: 'UPDATE_USER_E_SIGNATURE',
  UPDATING_USER_E_SIGNATURE: 'UPDATING_USER_E_SIGNATURE',
  UPDATE_USER_E_SIGNATURE_SUCCESS: 'UPDATE_USER_E_SIGNATURE_SUCCESS',
  UPDATE_USER_E_SIGNATURE_FAILED: 'UPDATE_USER_E_SIGNATURE_FAILED',

  DELETE_USER_E_SIGNATURE: 'DELETE_USER_E_SIGNATURE',
  DELETE_USER_E_SIGNATURE_LOADING: 'DELETE_USER_E_SIGNATURE_LOADING',
  DELETE_USER_E_SIGNATURE_SUCCESS: 'DELETE_USER_E_SIGNATURE_SUCCESS',
  DELETE_USER_E_SIGNATURE_FAILED: 'DELETE_USER_E_SIGNATURE_FAILED',

  FETCH_USER_E_SIGNATURE_URL: 'FETCH_USER_E_SIGNATURE_URL',
  FETCH_USER_E_SIGNATURE_URL_LOADING: 'FETCH_USER_E_SIGNATURE_URL_LOADING',
  FETCH_USER_E_SIGNATURE_URL_SUCCESS: 'FETCH_USER_E_SIGNATURE_URL_SUCCESS',
  FETCH_USER_E_SIGNATURE_URL_FAILED: 'FETCH_USER_E_SIGNATURE_URL_FAILED',

  GENERATE_LOGIN_OTP: 'GENERATE_LOGIN_OTP',
  GENERATING_LOGIN_OTP: 'GENERATING_LOGIN_OTP',
  GENERATE_LOGIN_OTP_FAILED: 'GENERATE_LOGIN_OTP_FAILED',
  GENERATE_LOGIN_OTP_SUCCESS: 'GENERATE_LOGIN_OTP_SUCCESS',
  RESET_GENERATE_LOGIN_OTP: 'RESET_GENERATE_LOGIN_OTP',

  GENERATE_FORGOT_OTP: 'GENERATE_FORGOT_OTP',
  GENERATING_FORGOT_OTP: 'GENERATING_FORGOT_OTP',
  GENERATE_FORGOT_OTP_FAILED: 'GENERATE_FORGOT_OTP_FAILED',
  GENERATE_FORGOT_OTP_SUCCESS: 'GENERATE_FORGOT_OTP_SUCCESS',
  RESET_GENERATE_FORGOT_OTP: 'RESET_GENERATE_FORGOT_OTP',

  UPDATE_ACTIVE_ROLE_MODULES: 'UPDATE_ACTIVE_ROLE_MODULES',
  UPDATE_IDENTITY: 'UPDATE_IDENTITY',

  UPDATE_OTP_SENDING: 'UPDATE_OTP_SENDING',
  UPDATING_OTP_SENDING: 'UPDATING_OTP_SENDING',
  UPDATE_OTP_SENDING_SUCCESS: 'UPDATE_OTP_SENDING_SUCCESS',
  UPDATE_OTP_SENDING_FAILED: 'UPDATE_OTP_SENDING_FAILED',

  FETCH_CHANGE_PASSWORD_DETAILS: 'FETCH_CHANGE_PASSWORD_DETAILS',
  FETCHING_CHANGE_PASSWORD_DETAILS: 'FETCHING_CHANGE_PASSWORD_DETAILS',
  FETCH_CHANGE_PASSWORD_DETAILS_SUCCESS: 'FETCH_CHANGE_PASSWORD_DETAILS_SUCCESS',
  FETCH_CHANGE_PASSWORD_DETAILS_FAILED: 'FETCH_CHANGE_PASSWORD_DETAILS_FAILED',

  SUBMIT_CHANGE_PASSWORD_DATA: 'SUBMIT_CHANGE_PASSWORD_DATA',
  SUBMITTING_CHANGE_PASSWORD_DATA: 'SUBMITTING_CHANGE_PASSWORD_DATA',
  SUBMIT_CHANGE_PASSWORD_DATA_SUCCESS: 'SUBMIT_CHANGE_PASSWORD_DATA_SUCCESS',
  SUBMIT_CHANGE_PASSWORD_DATA_FAILED: 'SUBMIT_CHANGE_PASSWORD_DATA_FAILED',

  DECODE_VALUE: 'DECODE_VALUE',
  DECODE_VALUE_SUCCESS: 'DECODE_VALUE_SUCCESS',
  DECODE_VALUE_FAILED: 'DECODE_VALUE_FAILED',

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: payload => ({
    type: actions.LOGIN_REQUEST,
    payload: payload
  }),
  decodeRequest: payload => ({
    type: actions.DECODE_VALUE,
    payload: payload
  }),
  signup: payload => ({
    type: actions.SIGNUP,
    loading: true,
    payload: payload
  }),
  logout: () => ({
    type: actions.LOGOUT
  }),
  clearError: () => ({
    type: actions.CLEAR_ERROR
  }),
  setSubmodules: payload => ({
    type: actions.SUBMODULES,
    modules: payload
  }),
  forgotPassword: payload => ({
    type: actions.FORGOT_PASSWORD,
    payload
  }),
  forgotError: () => ({
    type: actions.FORGOT_ERROR,
    label: 'Email not found'
  }),
  setHello: () => ({
    type: actions.SET_HELLO,
    label: 'HELLO 2'
  }),
  resetSecondTimer: payload => ({
    type: actions.RESET_SECOND_TIMER,
    secondTimer: payload
  }),
  fetchRedirectUrl: () => ({
    type: actions.FETCH_REDIRECT_URL
  }),
  fetchResetPassUrl: () => ({
    type: actions.FETCH_RESET_PASSWORD_URL
  }),
  resetChangePassword: () => ({
    type: actions.RESET_CHANGE_PASSWORD
  }),
  changePassword: payload => ({
    type: actions.CHANGE_PASSWORD,
    payload
  }),
  updateUserNotification: (payload, id) => ({
    type: actions.UPDATE_USER_NOTIFICATION,
    payload,
    id
  }),
  updateUserESignature: payload => ({
    type: actions.UPDATE_USER_E_SIGNATURE,
    payload
  }),
  deleteUserESignature: payload => ({
    type: actions.DELETE_USER_E_SIGNATURE,
    payload
  }),
  fetchUserESignatureURL: payload => ({
    type: actions.FETCH_USER_E_SIGNATURE_URL,
    payload
  }),
  updateUserOTPSending: payload => ({
    type: actions.UPDATE_OTP_SENDING,
    payload
  }),
  resetUpdateUserNotification: () => ({
    type: actions.RESET_UPDATE_USER_NOTIFICATION
  }),
  generateLoginOtp: payload => ({
    type: actions.GENERATE_LOGIN_OTP,
    payload: payload
  }),
  generateForgotOtp: payload => ({
    type: actions.GENERATE_FORGOT_OTP,
    payload: payload
  }),
  resetGenerateLoginOtp: () => ({
    type: actions.RESET_GENERATE_LOGIN_OTP
  }),
  resetGenerateForgotOtp: () => ({
    type: actions.RESET_GENERATE_FORGOT_OTP
  }),
  resetForgotPassword: () => ({
    type: actions.RESET_FORGOT_PASSWORD
  }),

  fetchChangePasswordDetails: payload => ({
    type: actions.FETCH_CHANGE_PASSWORD_DETAILS,
    payload
  }),
  submitChangePasswordData: payload => ({
    type: actions.SUBMIT_CHANGE_PASSWORD_DATA,
    payload
  }),
  forgotClear: () => ({
    type: actions.FORGOT_CLEAR
  }),
  forgotDescHide: () => ({
    // hide forgot pass desc
    type: actions.FORGOT_DESC_HIDE
  }),
  forgotDescShow: () => ({
    // hide forgot pass desc
    type: actions.FORGOT_DESC_SHOW
  })
};
export default actions;
